import SvgBack from '#/assets/images/icons/back.svg'
import Button from '#/components/Button'
import GeoAutocomplete from '#/components/GeoAutocomplete/advanced'
import { useGotoPlace } from '#/hooks/useGotoPlace'
import { property2Place } from '#/utils/property'
import useShowLocation from '../../hooks/useShowLocation'

type Props = {
  property: TopHap.Property
}

const DetailHeader: React.FC<Props> = ({ property }) => {
  const showLocation = useShowLocation(property, 'header')
  const handleChange = useGotoPlace()

  return (
    <div className='sticky top-header z-50 flex divide-x divide-gray-200 border-b border-gray-200 bg-primary-bg'>
      <Button className='space-x-2 px-3 text-xs text-gray-500' onClick={showLocation}>
        <SvgBack className='w-4' />
        <span>Map</span>
      </Button>
      <div className='flex-1 px-2 py-1'>
        <GeoAutocomplete
          multiple={false}
          placeholder='Address, Neighborhood, City or ZIP'
          value={property2Place(property)}
          onChange={handleChange}
        />
      </div>
    </div>
  )
}

export default DetailHeader
